var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"winner"}},[_c('h1',[_vm._v("GOOD JOB! You earned 100 points!")]),_c('button',{attrs:{"id":"myBtn"},on:{"click":_vm.increaseAndClose}},[_vm._v(" Collect Points ")])])}
var staticRenderFns = []

export { render, staticRenderFns }